<template>
  <div>
    <b-form-group label="Filter planmatig onderhoud">
      <b-input-group>
        <b-input-group-prepend is-text>
          <b-checkbox 
            v-model="filterUnits"
          >
            Alleen units met een bedrag in
          </b-checkbox>
        </b-input-group-prepend>
        <b-input-group-addon>
          <b-form-input 
            v-model.number="jaar" 
            type="number"
          />
        </b-input-group-addon>
        <b-input-group-addon is-text>
          {{ historie }} jaar historie &nbsp; <b-input 
            v-model="historie" 
            type="range" 
            min="0" 
            max="5"
          />
        </b-input-group-addon>
      </b-input-group>
    </b-form-group>
    <b-modal 
      v-model="aanvraagGestart" 
      title="Bestand wordt opgevraagd" 
      @ok="aanvraagGestart=false"
    >
      <b-progress 
        v-if="!downloadZipPath" 
        value="100" 
        animated 
        striped
      />
      <template v-else>
        <b-button 
          :href="liveLink" 
          size="lg" 
          block 
          target="_new"
        >
          <i class="fa fa-zip" /> Download ZIP
        </b-button>
        {{ liveLink }}
      </template>
    </b-modal>

    <b-table
      ref="unitTabel"
      :items="units"
      :fields="fields"
      :busy="isBusy"
      :tbody-tr-class="rowClass"
      small
      bordered
      hover
      selectable
      selected-variant="dark"
      @row-selected="onRowSelected"
    >
      <template slot="table-busy">
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle" />
          <strong class="mx-2">Laden...</strong>
        </div>
      </template>

      <template #cell()="data">
        <div v-if="data.item.Type !== null">
          <div v-if="(data.item.HuidigePrognose.Uitkomsten !== null)">
            {{
              (data.field.label <
                data.item.HuidigePrognose.Uitkomsten.prognose.start)
                ? "X"
                : data.item.HuidigePrognose.Uitkomsten.prognose.totalen[
                  data.field.label
                ] || "-"
            }}
          </div>
          <div v-else>
            ...
          </div>
        </div>
        <div v-else>
          {{
            data.field.label < data.item.Prognose.Start
              ? "x"
              : resultaat(data.item.Prognose)[data.field.label] || "-"
          }}
        </div>
      </template>
      <template #cell(Type)="data">
        <span 
          v-if="data.item.Type !== null"
        ><b-button
          :to="{
            name: 'Prognose',
            params: { prognoseid: data.item.HuidigePrognose.Id },
          }"
          size="sm"
          title="Link naar prognose"
        >{{ data.item.Type.discrimintatorvalue }}</b-button></span>
        <span v-else>TPA-klassiek</span>
      </template>

      <template #cell(Kenmerk)="props">
        <b-button
          :to="{ name: 'UnitViewRoute', params: { id: props.item.Id } }"
          size="sm"
          variant="info"
          title="Link naar unit"
        >
          {{ props.item.UnitKenmerk }}
        </b-button>
      </template>
      <template #cell(JSON)="props">
        <b-form-checkbox
          v-model="props.detailsShowing"
          @change="props.toggleDetails"
        >
          JSON
        </b-form-checkbox>
      </template>
      <template #cell(Selectie)="props">
        <i 
          v-if="props.rowSelected" 
          class="fa fa-check"
        />
        {{ props.index + 1 }}
      </template>
      <template #cell(Plaats)="props">
        {{
          props.item.WijkPlaats
        }}
      </template>
      <template #cell(Adres)="props">
        {{ props.item.Adres }}
      </template>
      <template #cell(Onderhoudsfirma)="props">
        {{
          props.item.Onderhoudsfirma
        }}
      </template>

      <template #cell(ConditieNa)="props">
        <div v-if="props.item.Type">
          nvt
        </div>
        <div v-else>
          {{ props.item.ConditieNa ? "ja" : "nee" }}
        </div>
      </template>

      <template #cell(BijgewerktOp)="props">
        <div v-if="props.item.Type">
          {{ props.item.HuidigePrognose.GemaaktOp | formatDateTime }}
        </div>
        <div v-else>
          {{ props.item.Prognose.GemaaktOp | formatDateTime }}
        </div>
      </template>

      <template #cell(Periode)="props">
        <div v-if="props.item.Type !== null">
          <div v-if="(props.item.HuidigePrognose.Uitkomsten !== null)">
            {{ props.item.HuidigePrognose.Uitkomsten.prognose.start }} -
            {{ props.item.HuidigePrognose.Uitkomsten.prognose.eind }} (-)
          </div>
          <div 
            v-else 
          >
            Uitkomsten niet gevonden!
          </div>
        </div>
        <div v-else>
          {{ props.item.Prognose.Start }} - {{ props.item.Prognose.Einde }} ({{
            props.item.Prognose.Lengte
          }})
        </div>
      </template>

      <template #row-details="row">
        {{ row }}
      </template>
    </b-table>
    <b-row>
      <b-col cols="3">
        <b-card no-body>
          <b-card-header>
            <b-card-title>Planmatig onderhoud aanvraag</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-button
              class="mb-2"
              block
              @click="$refs.unitTabel.selectAllRows()"
            >
              {{ filterUnits ? `Selecteer alle gefilterde units ${jaar}` : 'Selecteer alle units' }}
            </b-button>
            <b-form-group label="Installateur">
              <b-select
                v-model="installateur"
                :options="installateurs"
                text-field="Naam"
                value-field="Id"
              >
                <template #first>
                  <option 
                    value="null" 
                    disabled
                  >
                    -- Kies een onderhoudsfirma --
                  </option>
                </template>
              </b-select>
            </b-form-group>
            <pdf-sheets 
              key="export-bladen" 
              v-model="selectie"
            />
          </b-card-body>
          <b-card-footer>
            <b-button
              :disabled="installateur == null || selectedUnits.length == 0"
              class="pull-right"
              variant="primary"
              @click="POH"
            >
              Export aanvraag ZIP {{ selectedUnits.length }} unit(s)
            </b-button>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col><!---{{ getOrderedSheets(selectie) }} ---> </b-col>
    </b-row>
  </div>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import { pdfBladenMixin } from "@/mixins/pdfBladenMixin";
import PdfSheets from "@/components/PDFSheets";

export default {
  components: {
    PdfSheets,
  },
  mixins: [serviceMixin, pdfBladenMixin],
  props: {
    unit: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      startjaar: new Date().getFullYear(),
      alleUnits: [],
      installateurs: [],
      installateur: 15,
      historie: 3,
      downloadZipPath: null,
      filterUnits: false,
      selectedUnits: [],
      selectie: [
        "voorblad",
        "inventarisatie"
      ],
      jaren: 10,
      jaar: new Date().getFullYear() + 1,
      isBusy: false,
      aanvraagGestart: false,
    };
  },
  computed: {
    liveLink: function() {
      const baseUrl = process.env.VUE_APP_TPA_API_URL.replace(/\/index\.cfm$/, '');
      return baseUrl + this.downloadZipPath;
    },
    start: function () {
      return this.startjaar - this.historie;
    },
    eind: function () {
      return this.startjaar + this.jaren;
    },
    unitids: function () {
      return this.selectedUnits.map((unit) => unit.Id);
    },
    units: function () {
      var vm = this;
      var j = vm.jaar;
      if (this.filterUnits)
        return this.alleUnits.filter(function (u) {
          if (u.HuidigePrognose) {
            if (u.HuidigePrognose.Uitkomsten === null) return false;
            return u.HuidigePrognose.Uitkomsten.prognose.totalen[  j ]  > 0;  
          } else {
            return vm.resultaat(u.Prognose)[vm.jaar] > 0;
          }
        });
      return this.alleUnits;
    },
    overzicht: function () {
      var result = [];
      var start = this.start;
      while (start <= this.eind) {
        result.push(start);
        console.log(start);
        start++;
      }
      return result;
    },

    fields() {
      var columns = [
        { key: "Selectie", label: "" },
        "Type",
        "JSON",
        "Kenmerk",
        "Adres",
        "Plaats",
        "Onderhoudsfirma",
        "ConditieNa",

        "BijgewerktOp",
        { key: "Periode", label: "Periode (jrn.)" },
      ];
      this.overzicht.forEach(function (j, index) {
        columns.push({ key: "jaar" + index, label: j.toString() });
      });
      return columns;
    },
  },
  mounted() {
    this.getUnits();
    this.getOnderhoudsfirmas();
  },
  methods: {
    onRowSelected(items) {
      this.selectedUnits = items;
    },
    getOnderhoudsfirmas() {
      var vm = this;
      this.get("/onderhoud/relaties")
        .then(function (response) {
          console.dir(response.data);
          vm.installateurs = response.data.relaties;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    POH() {
      var vm = this;
      this.aanvraagGestart = true;
      this.downloadZipPath = null;
      this.post("/planmatig/" + this.jaar + "/aanvraag/" + this.installateur, {
        units: this.unitids,
        bladen: this.getOrderedSheets(this.selectie),
      })
        .then(function (response) {
          console.dir(response.data);
          vm.downloadZipPath = response.data.boodschap;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    resultaat(data) {
      var result = {};
      if (data.Uitkomsten) {
        for (var i = 0; i < data.Uitkomsten.length; i++) {
          result[data.Start + i] = data.Uitkomsten[i];
        }
      }
      return result;
    },
    rowClass(item, type) {
      if (type != "row") return;
      if (item.Type !== null && item.HuidigePrognose.Uitkomsten === null) return "bg-danger text-white";
      if (item.Id == this.$route.params.id) return "bg-info";
      return;
    },
    getUnits() {
      var vm = this;
      vm.isBusy = true;
      this.get(`/relaties/${this.unit.Complex.Relatie.Id}/units/export`)
        .then(function (response) {
          console.dir(response.data);
          vm.alleUnits = response.data.units;
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          vm.isBusy = false;
        });
    },
  },
};
</script>